
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface TitleSectionProps {
  title_en: string;
  setTitleEn: (value: string) => void;
  title_ko: string;
  setTitleKo: (value: string) => void;
  isEnglish: boolean;
}

// Recommended title length so the card heading stays within ~2 lines.
// Korean is denser (fewer characters per line), so it gets a lower target.
const TITLE_TARGET = { en: 60, ko: 36 };

const TitleSection = ({ title_en, setTitleEn, title_ko, setTitleKo, isEnglish }: TitleSectionProps) => {
  const value = isEnglish ? title_en : title_ko;
  const target = isEnglish ? TITLE_TARGET.en : TITLE_TARGET.ko;
  const count = value.length;
  const isOver = count > target;

  return (
    <div className="space-y-1.5">
      <Input
        placeholder={isEnglish ? "English Title" : "한국어 제목"}
        value={isEnglish ? title_en : title_ko}
        onChange={(e) => isEnglish ? setTitleEn(e.target.value) : setTitleKo(e.target.value)}
        className="text-lg font-medium border-gray-200 focus:border-gray-300 focus:ring-gray-200"
      />
      <div className="flex justify-end">
        <span
          className={cn(
            'text-xs tabular-nums',
            isOver ? 'font-medium text-amber-600' : 'text-gray-400'
          )}
        >
          {count} / ~{target}
        </span>
      </div>
    </div>
  );
};

export default TitleSection;
